<div class="sticky-bar">
    <div class="w3-container w3-padding-12" style="background:white;">
        <div class="row">
            <div class="w3-col m1 w3-hide-small">
                <img src="../../../assets/activitiesImages/logo_gov.png">
            </div>
            <div class="w3-left w3-margin-top w3-padding-12" style="width: 150px;">
                <img src="../../../assets/activitiesImages/cada_logo.png">
            </div>
            <div class="w3-col m5">
                <!-- <h3 style="font-weight:bold; margin-bottom:0px; margin-top:30px; color: #a91e22; font-size: 1.4rem;">
                  Micro
                  Irrigation &amp;
                  Command Area
                  Development Authority, Haryana</h3> -->
                  <h3 style="font-weight:bold; margin-bottom:0px; margin-top:30px; color: #a91e22; font-size: 1.4rem;">
                    {{'MICADA_HEADING'| translate}}</h3>
                <!-- <span style="color: #a91e22"><b> (Formerly CADA) </b></span> -->
              </div>
        </div>

        <div class="w6-col m3 w3-right button-div d-flex" style="text-align: right;">
          <label><b>{{'LANGUAGE' | translate}} :</b></label>
          <p-dropdown [(ngModel)]="selectedLang"[options]='[{name: "English", code:"en"}, {name: "Hindi",code:"hd"}]' optionLabel="name"
          (onChange)="languageChange($event)" style="margin-left: 2px">
       </p-dropdown>
          <button type="button" class="button-33 mx-3"><a [routerLink]="['/login']"><b>{{'LOGIN'| translate}}</b></a></button>
             <button pButton class="button-33 mx-3" type="button"><a [routerLink]="['/phone-login']"><b>{{'FARMER_LOGIN'| translate}}</b></a></button>
         </div>
    </div>

    <section class="top-nav">
        <input id="menu-toggle" type="checkbox" />
        <label class='menu-button-container' for="menu-toggle">
            <div class='menu-button'></div>
        </label>
        <ul class="menu" style="display: flex; justify-content: center;">
            <li><a [routerLink]="['/home']">{{'HOME'| translate}}</a></li>
            <li><a href="https://etenders.hry.nic.in/nicgep/app" target="_blank">{{'TENDER/EOI'| translate}}</a></li>
            <li><a [routerLink]="['/activities']">{{'ACTIVITIES'| translate}}</a></li>
            <li><a [routerLink]="['/statistics']">{{'STATISTICS'| translate}}</a></li>
            <li><a href="https://micada.haryana.gov.in:7002/" target="_blank">{{'CADMIS'| translate}}</a></li>
            <li><a [routerLink]="['/rti']">{{'RTI'| translate}}</a></li>
            <li><a [routerLink]="['/new-initiatives']">{{'NEW_INTIATIVES'| translate}}</a></li>
            <li><a [routerLink]="['/org-setup']">{{'ORGANIZATIONAL_SETUP'| translate}}</a></li>
          </ul>
    </section>
</div>


<div class="w3-col m10 w3-margin-top top-container1" style="width: 100%; height: 100%; display: block;">
    <div class="w3-container">
        <p-galleria [value]="images" [responsiveOptions]="responsiveOptions"
            [containerStyle]="{'max-width': '100%', 'height': '100%'}" [numVisible]="5" [showThumbnails]="false"
            [showIndicators]="true" [changeItemOnIndicatorHover]="true" [autoPlay]="true" [transitionInterval]="3000"
            [circular]="true">
            <ng-template pTemplate="item" let-item>
                <img [src]="item.previewImageSrc" style="width: 100%; height: 350px; display: block;" />
            </ng-template>
            <ng-template pTemplate="thumbnail" let-item>
                <div class="grid grid-nogutter justify-content-center">
                    <img [src]="item.thumbnailImageSrc" style="display: block;" />
                </div>
            </ng-template>
        </p-galleria>
    </div>
</div>


<div class="row p-0 mt-4 lg:mt-0 pl-5 grid" style="width:100%;">
    <div class="col-12 md:col-4 lg:col-4" style="text-align: center;">
      <img src="../../../assets/activitiesImages/manhorlal.jpg" style="width:150px;height:130px; border-radius: 50%;">
      <p style="font-size:16px; color:rgb(168, 15, 15);"><b>{{'SH_MANOHAR_LAL'| translate}}<p
            style="font-size:12px; color:black; font-weight:bold">{{'CHIEF_MINISTER'| translate}}<br>
            {{'HARYANA'| translate}}</p></b></p>
    </div>
    <div class="col-12 md:col-4 lg:col-4" style="text-align: center;">
      <img src="../../../assets/activitiesImages/ACS.jpg" style="width:150px;height:130px; border-radius: 50%;">
      <p style="font-size:16px; color:rgb(168, 15, 15)"><b>{{'SH_PANKAJ_AGARWAL'| translate}}<p
            style="font-size:12px; color:black; font-weight:bold">{{'COMMMISSIONER_AND_SECRETARY'| translate}},<br>{{'IRRIGATION_AND_WATER_DEPT'| translate}} <br/>{{'HARYANA'| translate}}</p></b></p>
    </div>
    <div class="col-12 md:col-4 lg:col-4" style="text-align: center;">
      <img src="../../../assets/activitiesImages/admin.jpg" style="width:150px;height:130px; border-radius: 50%;">
      <p style="font-size:16px; color:rgb(168, 15, 15)"><b>{{'DR_SATBIR_SINGH'| translate}}<p
            style="font-size:12px; color:black; font-weight:bold">{{'ENGINNER_IN_CHIEF'| translate}}<br>
            {{'ADMINISTRATOR'| translate}}<br>
            {{'CADA_HARYANA'| translate}}</p></b></p><br>
    </div>
  </div>

<div class="px-3">
    <div class="w3-col m2 w3-container w3-margin-bottom info-container1 w3-center w3-hover-shadow w3-border">
        <ul class="w3-ul w3-margin-top" style="font-size:12px;">
    
          <li class="w3-large w3-padding-16" style="background:darkseagreen; color:black"><b>{{'QUICK_LINKS'| translate}}</b></li>
          <marquee direction="up" onmouseover="this. stop();" onmouseout="this.start();" style="max-height: 430px;">
            <li class="w3-padding-8 w3-left-align">{{'ADVERTISEMENT_DATE'| translate}}
              <a href="http://cada.hartron.io/assets/home/Appointment%20Regarding%20Document.pdf" target="_blank"><img
                  src="../../../assets/activitiesImages/newitem.gif"></a>
            </li>
            <li class="w3-padding-8  w3-left-align">{{'WATER_POLICY'| translate}}<a
                href="http://cada.hartron.io/assets/home/waterpolicy2122.pdf" target="_blank"><img
                  src="../../../assets/activitiesImages/newitem.gif"></a></li>
    
            <li class="w3-padding-8  w3-left-align">{{'FARMER_ONLINE_APP_WEB_PORTAL_FOR_MI'| translate}}<a
                href="http://cada.hartron.io/phone-login" target="_blank">
                <img src="../../../assets/activitiesImages/newitem.gif">
              </a></li>
            <li class="w3-padding-8  w3-left-align">MICADA PORTAL से सम्बंधित योजनाओ की जानकारी हेतु आप हेल्पलाइन संख्या
              0172 - 2800610 पर 9.00 AM to 5.00 PM संपर्क कर सकते है</li>
            <li class="w3-padding-8  w3-left-align">{{'ON_FARM_WATER_TANK_POLICY'| translate}}
              <a href="http://cada.hartron.io/assets/home/On%20Farm%20Water%20Tank%20Policy%20Final-%202020-21.pdf"
                target="_blank">
                <img src="../../../assets/activitiesImages/newitem.gif"></a>
            </li>
    
            <li class="w3-padding-8  w3-left-align">{{'IMPLEMENTATION_GUIDELINES'| translate}}
              <a href="http://cada.hartron.io/assets/home/Guidelines%20MI.pdf" target="_blank"><img
                  src="../../../assets/activitiesImages/newitem.gif"></a>
            </li>
    
            <li class="w3-padding-8  w3-left-align">{{'MI_CIRCULAR'| translate}}<a href="http://cada.hartron.io/home"
                target="_blank"><img src="../../../assets/activitiesImages/newitem.gif"></a></li>
    
            <li class="w3-padding-8  w3-left-align">{{'AAROGYA_SETU_IVRS'| translate}}<a
                href="http://cada.hartron.io/assets/home/AarogyaSetuIVRS.pdf" target="_blank"><img
                  src="../../../assets/activitiesImages/newitem.gif"></a></li>
          </marquee>
        </ul>
      </div>


    <div class="w3-col m8 w3-container w3-margin-bottom info-container2 w3-center w3-hover-shadow w3-borderB">
        <h5 style="color:rgb(22, 21, 21); background:darkseagreen;" class="px-3"><b>{{'PROJECTS_UNDER_MICRO_IRRIGATION'| translate}}</b>
        </h5>
        <p style="font-size:11px; margin-left:15px; margin-right:10px; color:black; text-align: justify;">
            <b>i) {{'PROJECTS_UNDER_MICRO_IRRIGATION_1'| translate}} <br><br>
                ii) {{'PROJECTS_UNDER_MICRO_IRRIGATION_2'| translate}}<br><br>
                iii) {{'PROJECTS_UNDER_MICRO_IRRIGATION_3'| translate}}
            </b>
        </p>

        <h5 style="color:rgb(22, 21, 21); background:darkseagreen;" class="px-3"><b>{{'ON_GOING_PROJECT'| translate}}</b>
        </h5>
        <p style="font-size:11px; margin-left:15px; margin-right:10px; color:black; text-align: justify;">
            <b>iv) {{'PROJECTS_UNDER_MICRO_IRRIGATION_4'| translate}}<br>
            </b>
        </p>
    </div>

    <div class="w3-col m2 w3-container w3-margin-bottom info-container3 w3-center w3-hover-shadow w3-border">
        <ul class="w3-ul w3-margin-top" style="font-size:12px;">
    
          <li class="w3-large w3-padding-16" style="background:darkseagreen; color:black"><b>{{'NEWS_AND_EVENTS'| translate}}</b></li>
          <marquee direction="up" onmouseover="this. stop();" onmouseout="this.start();" style="max-height: 430px;">
            <li class="w3-padding-16 w3-left-align"><b>{{'FARMER_ONLINE_APPLICATION_FOR_MI'| translate}}</b><br>
              <p>{{'FARMER_ONLINE_APPLICATION_HAS_BEEN_INAUGURATED'| translate}}</p>
            </li>
            <li class="w3-padding-16  w3-left-align"><b>{{'CADA_ADMINISTRATOR'| translate}}</b><br>
              <p>{{'DR_SATBIR_SINGH_KADIAN_EIC'| translate}}</p>
            </li>
    
            <li class="w3-padding-16  w3-left-align"><b>{{'CADA_CHIEF_ENGINEER'| translate}}</b><br>
              {{'SH_SURESH_YADAV'| translate}}</li>
    
            <li class="w3-padding-24 w3-left-align"></li>
            <li class="w3-padding-16 w3-left-align"></li>
          </marquee>
        </ul>
      </div>
</div>


<div class="grid col-12 md:col-12 lg:col-12 p-0 mt-4 lg:mt-0 pl-5" style="width:100%;">
    <!-- <div class="col-6 md:col-2 lg:col-2 pr-5 p-0 lg:pr-5  mt-4 lg:mt-0 mb-2 dropdown">
        <div class="px-3" style="
            height: 160px;
            padding: 2px;
            border-radius: 10px;
            background: linear-gradient(
                90deg,
                rgba(253, 228, 165, 0.2),
                rgba(187, 199, 205, 0.2)
              ),
              linear-gradient(
                180deg,
                rgba(253, 228, 165, 0.2),
                rgba(187, 199, 205, 0.2)
              );
          ">
            <a class="p-3 h-full" style="border-radius: 8px">
                <div class="flex align-items-center justify-content-center bg-yellow-200 mb-3"
                    style="width: 3.5rem; height: 3.5rem; border-radius: 10px">
                    <i class="pi pi-fw pi-money-bill text-2xl text-yellow-700"></i>
                </div>
                <h5 class="mb-2 text-900">Farmer Share Payment</h5>
                <div class="dropdown-content">
                    <a href="assets/home/farmer_share_payment_s1.pdf" target="_blank">Farmer Share Lot 1</a>
                    <a href="assets/home/farmer_share_payment_s2.pdf" target="_blank">Farmer Share Lot 2</a>
                </div>
            </a>
        </div>
    </div>

    <div class="col-6 md:col-2 lg:col-2 pr-5 p-0 lg:pr-5  mt-4 lg:mt-0 mb-2">
        <div class="px-3" style="
            height: 160px;
            padding: 2px;
            border-radius: 10px;
            background: linear-gradient(
                90deg,
                rgba(145, 226, 237, 0.2),
                rgba(251, 199, 145, 0.2)
              ),
              linear-gradient(
                180deg,
                rgba(253, 228, 165, 0.2),
                rgba(172, 180, 223, 0.2)
              );
          ">
            <a [routerLink]="['/evaluation-study']" class="p-3  h-full" style="border-radius: 8px">
                <div class="flex align-items-center justify-content-center bg-cyan-200 mb-3"
                    style="width: 3.5rem; height: 3.5rem; border-radius: 10px">
                    <i class="pi pi-fw pi-palette text-2xl text-cyan-700"></i>
                </div>
                <h5 class="mb-2 text-900">Evaluation Study</h5>
            </a>
        </div>
    </div>

    <div class="col-6 md:col-2 lg:col-2 p-0 pr-5 lg:pr-5 mt-4 lg:mt-0">
        <div class="px-3" style="
            height: 160px;
            padding: 2px;
            border-radius: 10px;
            background: linear-gradient(
                90deg,
                rgba(145, 226, 237, 0.2),
                rgba(172, 180, 223, 0.2)
              ),
              linear-gradient(
                180deg,
                rgba(172, 180, 223, 0.2),
                rgba(246, 158, 188, 0.2)
              );
          ">
            <a [routerLink]="['/micro-irrigation']" class="p-3 h-full" style="border-radius: 8px">
                <div class="flex align-items-center justify-content-center bg-indigo-200"
                    style="width: 3.5rem; height: 3.5rem; border-radius: 10px">
                    <i class="pi pi-fw pi-map text-2xl text-indigo-700"></i>
                </div>
                <h5 class="mb-2 text-900">Micro Irrigation</h5>
            </a>
        </div>
    </div>

    <div class="col-6 md:col-2 lg:col-2 pr-5 p-0 lg:pr-5  mt-4 lg:mt-0 mb-2">
        <div class="px-3" style="
            height: 160px;
            padding: 2px;
            border-radius: 10px;
            background: linear-gradient(
                90deg,
                rgba(187, 199, 205, 0.2),
                rgba(251, 199, 145, 0.2)
              ),
              linear-gradient(
                180deg,
                rgba(253, 228, 165, 0.2),
                rgba(145, 210, 204, 0.2)
              );
          ">
            <a [routerLink]="['/project']" class="p-3 h-full" style="border-radius: 8px">
                <div class="flex align-items-center justify-content-center bg-bluegray-200 mb-3"
                    style="width: 3.5rem; height: 3.5rem; border-radius: 10px">
                    <i class="pi pi-fw pi-id-card text-2xl text-bluegray-700"></i>
                </div>
                <h5 class="mb-2 text-900">Projects</h5>
            </a>
        </div>
    </div>

    <div class="col-6 md:col-2 lg:col-2 p-0 pr-5 lg:pr-5  mt-4 lg:mt-0">
        <div class="px-3" style="
            height: 160px;
            padding: 2px;
            border-radius: 10px;
            background: linear-gradient(
                90deg,
                rgba(187, 199, 205, 0.2),
                rgba(246, 158, 188, 0.2)
              ),
              linear-gradient(
                180deg,
                rgba(145, 226, 237, 0.2),
                rgba(160, 210, 250, 0.2)
              );
          ">
            <a [routerLink]="['/annual-plan']" class="p-3 h-full" style="border-radius: 8px">
                <div class="flex align-items-center justify-content-center bg-orange-200 mb-3"
                    style="width: 3.5rem; height: 3.5rem; border-radius: 10px">
                    <i class="pi pi-fw pi-star text-2xl text-orange-700"></i>
                </div>
                <h5 class="mb-2 text-900">Annual Plan</h5>
            </a>
        </div>
    </div>

    <div class="col-6 md:col-2 lg:col-2 p-0 pr-5 lg:pr-5  mt-4 lg:mt-0">
        <div class="px-3" style="
      height: 160px;
      padding: 2px;
      border-radius: 10px;
      background: linear-gradient(
          90deg,
          rgba(251, 199, 145, 0.2),
          rgba(246, 158, 188, 0.2)
        ),
        linear-gradient(
          180deg,
          rgba(172, 180, 223, 0.2),
          rgba(212, 162, 221, 0.2)
        );">
            <a [routerLink]="['/achievements']" class="p-3 h-full" style="border-radius: 8px">
                <div class="flex align-items-center justify-content-center bg-orange-200 mb-3"
                    style="width: 3.5rem; height: 3.5rem; border-radius: 10px">
                    <i class="pi pi-fw pi-star text-2xl text-orange-700"></i>
                </div>
                <h5 class="mb-2 text-900">Achievements</h5>
            </a>
        </div>
    </div> -->
</div>



<footer class="w3-container w3-center" style="background:darkseagreen;height:120px; color:black;">
    <div class="w3-row-padding">
      <div class="w3-center w3-bar-item" style="margin-bottom:5px; color:black;">
        <p><b><strong>{{'MICADA_HARYANA'| translate}}</strong></b><br><b>
          {{'BAYS_39_40_SECTOR_4_PANCHKULA'| translate}}<br>
          {{'FAX_NO'| translate}}<br>
          {{'EMAIL'| translate}}:hrcada@chd.nic.in</b></p>
        <p class="w3-hide-medium w3-hide-small" style="color:rgb(71, 3, 3);"><b>
           Copyright © 2021 Micro Irrigation &
            Command Area Development Authority, Haryana. All Rights Reserved.</b>
        </p>
      </div>
    </div>
  </footer>